export default __webpack_public_path__ + "static/media/c008-2.471b3f9b.svg";